module.exports = function() {
  return new Worker(__webpack_public_path__ + "0c9f0f15fa40b85a6f5f.worker.js");
};